"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LENGTH_UNITS = exports.LENGTH_UNITS = Object.freeze({
  REM: "rem",
  PX: "px",
  EM: "em"
});

var ANGLE_UNITS = exports.ANGLE_UNITS = Object.freeze({
  DEG: "deg",
  RAD: "rad",
  GRAD: "grad",
  TURN: "turn"
});

var PERCENT_UNIT = exports.PERCENT_UNIT = "%";

var DIRECTIONS = exports.DIRECTIONS = Object.freeze({
  TOP: "top",
  RIGHT: "right",
  BOTTOM: "bottom",
  LEFT: "left"
});


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/const/units.js
// module id = 133
// module chunks = 168707334958949